<template>
  <Form ref="caseInfoForm" :model="caseInfoForm" label-position="left" :label-width="140" :rules="ruleCaseInfo">
    <Row type="flex" justify="space-around">
      <Col span="8">
        <FormItem :label="$t('addNewCase.caseInfo.pathologyNumber')"  prop="pathologyId">
          <Input type="text" maxlength="15" :placeholder="$t('addNewCase.caseInfo.pathologyNumberPlaceholder')" class="inputWidth" v-model="caseInfoForm.pathologyId"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('addNewCase.caseInfo.rapidCase')" required>
          <RadioGroup v-model="caseInfoForm.isQuickCase">
            <Radio  v-for="item in isQuicks" :value="item.label" :key="item.label" :label="item.label" style="padding-left: 30px">{{ item.value }}</Radio>
          </RadioGroup>
        </FormItem>
      </Col>
    </Row>
    <Row type="flex" justify="space-around">
      <Col span="8">
        <FormItem :label="$t('addNewCase.caseInfo.caseType')" prop="pathologyType">
          <Select class="inputWidth" v-model="caseInfoForm.pathologyType">
            <Option v-for="item in bllxList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('addNewCase.caseInfo.inspectionDepartment')">
          <Select v-model="caseInfoForm.caseDepart" class="inputWidth" clearable filterable allow-create @on-create="pushSjbmList">
            <Option v-for="item in sjbmList" :value="item.label" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Col>
    </Row>
    <Row type="flex" justify="space-around">
      <Col span="8">
        <FormItem :label="$t('addNewCase.caseInfo.inspectionDate')" required>
          <DatePicker :clearable="false" type="datetime" :placeholder="$t('addNewCase.caseInfo.inspectionDatePlaceholder')" class="inputWidth" v-model="caseInfoForm.sendDate" format="yyyy-MM-dd HH:mm:ss"></DatePicker>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('addNewCase.caseInfo.sendingDoctor')" prop="sendDoctor">
          <Tooltip :disabled="sendDoctorDisabled" theme="light" :content="$t('addNewCase.caseInfo.sendingDoctorTip')">
            <AutoComplete
              v-model="caseInfoForm.sendDoctor"
              :data="sendDoctorHistoryList"
              @on-change="checkSendDoctorLength"
              @on-blur="checkSendDoctorLength"
              :placeholder="$t('addNewCase.caseInfo.sendingDoctorPlaceholder')"
              class="inputWidth">
            </AutoComplete>
          </Tooltip>
<!--          <Input type="text" placeholder="请输入送检医生" style="width: 150px" v-model="caseInfoForm.sendDoctor"></Input>-->
        </FormItem>
      </Col>
    </Row>
    <!--=====================送检医院位置 start=================-->
    <Row type="flex" justify="space-around">
      <Col span="22">
        <FormItem :label="$t('addNewCase.caseInfo.sentToHospital')" prop="sendHospitalId">
          <Select v-model="caseInfoForm.sendHospitalId" style="width:78%">
            <Option v-for="item in sendHospitalList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Col>
    </Row>
    <!--=====================送检医院位置 end=================-->
    <div v-for="(sample, index) in caseInfoForm.samples" :key="index">
      <Row type="flex" justify="space-around">
        <Col span="7">
          <FormItem
            :label="$t('addNewCase.caseInfo.sampleType')"
            :prop="'samples.' + index + '.sampleTypes'"
            :rules="{required: true, message: $t('addNewCase.caseInfo.sampleTypeMessage')}"
          >
            <Tooltip :disabled="sampleTypesDisabled" theme="light" :content="$t('addNewCase.caseInfo.sampleTypeTip')">
              <AutoComplete
                v-model="sample.sampleTypes"
                :data="sampleTypeHistoryList"
                @on-change="checkSampleTypesLength(index)"
                @on-blur="checkSampleTypesLength(index)"
                @on-focus="updateSampleTypesDisabled"
                :placeholder="$t('addNewCase.caseInfo.sampleTypePlaceholder')"
                style="width: 150px">
              </AutoComplete>
            </Tooltip>
            <!--<Input type="text" placeholder="请输入样本类型" style="width:100px" v-model="sample.sampleTypes"></Input>-->
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem
            :label="$t('addNewCase.caseInfo.analysisType')"
            :prop="'samples.' + index + '.pathologyType'"
            :rules="{required: true, message: $t('addNewCase.caseInfo.analysisTypeMessage'), trigger: 'blur'}"
          >
            <Select v-model="sample.pathologyType" style="width:120px;margin-left: -15px">
              <Option v-for="(item, index) in fxffList" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem
            :label="$t('addNewCase.caseInfo.numberOfSlides')"
            :prop="'samples.' + index + '.bpsl'"
          >
            <InputNumber :max="200" :min="1" v-model="sample.bpsl"  style="width:60px;margin-left: -20px"></InputNumber>
          </FormItem>
        </Col>
        <Col span="2">
          <Dropdown>
            <Button type="primary">
              {{$t('addNewCase.caseInfo.operationButton')}}
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem><Button type="primary"  @click="uploadMaterials(index)" icon="ios-cloud-upload">{{$t('addNewCase.caseInfo.selectPictureButton')}}</Button></DropdownItem>
              <DropdownItem><Button type="error"  @click="handleRemove(index)" icon="md-remove">{{$t('addNewCase.caseInfo.deleteButton')}}</Button></DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Col>
      </Row>
    </div>
    <Button type="primary" @click="handleAdd" icon="md-add" class="addSampleButton">{{$t('addNewCase.caseInfo.addSampleButton')}}</Button>
    <div v-if="isShowMoreCaseInfo">
      <Row type="flex" justify="space-around">
        <Col span="8">
          <FormItem :label="$t('addNewCase.caseInfo.hospitalNumber')">
            <Input type="text"  maxlength="15" :placeholder="$t('addNewCase.caseInfo.hospitalNumberPlaceholder')" class="inputWidth" v-model="caseInfoForm.patInhospitalId"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('addNewCase.caseInfo.ward')">
            <Input type="text"  maxlength="15" :placeholder="$t('addNewCase.caseInfo.wardPlaceholder')" class="inputWidth" v-model="caseInfoForm.patWardArea"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="space-around">
        <Col span="8">
          <FormItem :label="$t('addNewCase.caseInfo.bedNumber')">
            <Input type="text"  maxlength="15" :placeholder="$t('addNewCase.caseInfo.bedNumberPlaceholder')" class="inputWidth" v-model="caseInfoForm.patBedId"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('addNewCase.caseInfo.phoneNumberOfSendingPhysician')" prop="sendDoctorPhone">
            <Input type="text"  maxlength="11" :placeholder="$t('addNewCase.caseInfo.phoneNumberOfSendingPhysicianPlaceholder')" class="inputWidth" v-model="caseInfoForm.sendDoctorPhone"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="space-around">
        <Col span="8">
          <FormItem :label="$t('addNewCase.caseInfo.menstruateLastTime')">
            <DatePicker type="date" :placeholder="$t('addNewCase.caseInfo.menstruateLastTimePlaceholder')" class="inputWidth" v-model="caseInfoForm.lastTransitTime" format="yyyy-MM-dd"  @on-change="caseInfoForm.lastTransitTime=$event"></DatePicker>
          </FormItem>
        </Col>
        <Col span="12">

        <FormItem :label="$t('addNewCase.caseInfo.deadline')">
          <DatePicker type="datetime" :placeholder="$t('addNewCase.caseInfo.deadlinePlaceholder')" class="inputWidth" v-model="caseInfoForm.deadline" format="yyyy-MM-dd HH:mm:ss"  @on-change="caseInfoForm.deadline=$event"></DatePicker>
        </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="space-around">
        <Col span="22">
          <FormItem :label="$t('addNewCase.caseInfo.medicalHistory')" labelWidth:80>
            <Input type="textarea"  maxlength="255" show-word-limit :placeholder="$t('addNewCase.caseInfo.medicalHistoryPlaceholder')" style="width:80%" v-model="caseInfoForm.medicalHistory"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="space-around">
        <Col span="22">
          <FormItem :label="$t('addNewCase.caseInfo.clinicalDiagnosis')" labelWidth:80>
            <Input type="textarea"  maxlength="255" :placeholder="$t('addNewCase.caseInfo.clinicalDiagnosisPlaceholder')" show-word-limit style="width:80%" v-model="caseInfoForm.clinicalDiagnosis"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="space-around">
        <Col span="22">
          <FormItem :label="$t('addNewCase.caseInfo.visibleToTheNakedEye')" labelWidth:80>
            <Input type="textarea"  maxlength="255" show-word-limit :placeholder="$t('addNewCase.caseInfo.visibleToTheNakedEyePlaceholder')" style="width:80%" v-model="caseInfoForm.caseDesc"></Input>
          </FormItem>
        </Col>
      </Row>
    </div>
    <Row @click.native="showMoreCaseInfo">
      <Col span="3" style="position: relative; top: -10px;margin-left: 25px">
        <a style="font-size: 16px; font-weight: 500; color: #2db7f5" >
          <span>{{moreText}}</span>
          <Icon v-show="isShowMoreCaseInfo === false" type="ios-arrow-down"></Icon>
          <Icon v-show="isShowMoreCaseInfo === true" type="ios-arrow-up"></Icon>
        </a>
      </Col>
    </Row>
    <div v-if="isShowMaterials">
      <Modal
        v-model="isShowMaterials"
        :closable="false"
        :mask-closable="false"
        scrollable
        :styles="{top: '20px'}"
        width = "900px"
        :title="$t('addNewCase.caseInfo.imageManagement')">
        <drawing-image-management @getUploadList="getUploadList" :uploadList="uploadList" :editOrAdd="addMaterials"></drawing-image-management>
        <div slot="footer">
          <Button type="primary" size="large"  style="width: 80px" @click="cancel()">{{$t('addNewCase.caseInfo.cancel')}}</Button>
          <Button type="primary" size="large"  style="width: 80px" @click="complete()">{{$t('addNewCase.caseInfo.confirm')}}</Button>
        </div>
      </Modal>
    </div>
  </Form>
</template>

<script>
import DrawingImageManagement from './DrawingImageManagement'
export default {
  name: 'PatientInfo',
  props: {
    caseInfoMesage: {
      type: Array,
      default: null
    }
  },
  components: {DrawingImageManagement},
  data () {
    // 验证手机号码
    const sendDoctorPhone = (rule, value, callback) => {
      let reg = /(^1(2|3|4|5|6|7|8)\d{9}$)/
      if (value === '') {
        callback()
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('addNewCase.caseInfo.phoneNumberTip')))
      } else {
        callback()
      }
    }
    return {
      $vue: '',
      sendDoctorHistoryList: [], //  送检医生历史记录
      sampleTypeHistoryList: [], // 样本类型历史记录
      sampleCount: 0, // 样本数量
      addMaterials: 'addMaterials', // 添加取材图像标识位
      uploadList: [], // 取材图片预览信息
      sampleIndex: '', // 样本数组的下标
      files: [],
      isFullscreen: true,
      isShowMaterials: false, // 是否展示取材台图片模态框
      moreText: this.$t('addNewCase.moreInformation'),
      isShowMoreCaseInfo: false, // 是否显示更多
      sjbmList: '', // 送检部门
      bllxList: '', // 病例类型
      sendHospitalList: '', // 送检医院列表
      // 染色类型
      rslxList: '',
      fxffList: '', // 分析方法
      sendDoctorDisabled: true,
      sampleTypesDisabled: true,
      // 病例信息
      caseInfoForm: {
        pathologyId: '', // 病理号
        isQuickCase: '0', // 是否快速
        pathologyType: '', // 病例类型
        caseDepart: '', // 送检科室
        sendDoctor: '', // 送检医生
        sendHospitalId: '', // 送检医院Id
        sendDate: new Date(), // 送检日期
        patInhospitalId: '', // 住院号
        patWardArea: '', // 病区
        patBedId: '', // 病床号
        sendDoctorPhone: '', // 送检医师电话
        lastTransitTime: '', // 最后行经时间
        deadline: '', // 截止时间
        medicalHistory: '', //  病史
        clinicalDiagnosis: '', //  临床诊断
        caseDesc: '', // 肉眼所见
        // 样本列表
        samples: [
          {
            sampleTypes: '', // 样本类型
            pathologyType: '', // 分析类型
            bpsl: 1, // 玻片数量
            uploadList: [] // 取材图预览信息
          }
        ]
      },
      // 是否快速
      isQuicks: [
        {
          value: this.$t('addNewCase.caseInfo.isFast.yes'),
          label: '1'
        },
        {
          value: this.$t('addNewCase.caseInfo.isFast.no'),
          label: '0'
        }
      ],
      ruleCaseInfo: {
        pathologyId: [
          { required: true, message: this.$t('addNewCase.caseInfo.pathologyNumberTip'), trigger: 'blur' }
        ],
        pathologyType: [
          { required: true, message: this.$t('addNewCase.caseInfo.CaseTypeTip'), trigger: 'blur' }
        ],
        // caseDepart: [
        //   { required: true, message: this.$t('addNewCase.caseInfo.inspectionDepartmentTip'), trigger: 'blur' }
        // ],
        sendHospitalId: [
          { required: true, message: this.$t('addNewCase.caseInfo.sentToHospitalTip'), trigger: 'blur' }
        ],
        /*  sendDate: [
          { required: true, message: '请输入送检日期！', trigger: 'blur' }
        ], */
        sendDoctor: [
          { required: true, message: this.$t('addNewCase.caseInfo.sendingDoctorMessage') }
        ],
        sendDoctorPhone: [
          { validator: sendDoctorPhone, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'caseInfoMesage': function () {
      this.caseInfoForm.caseDepart = this.caseInfoMesage[0]
      this.caseInfoForm.sendDoctor = this.caseInfoMesage[1]
    }
  },
  beforeMount () {
    this.$vue = this
    this.getDicInfo()
    this.getHospitalList()
    this.sendDoctorHistoryList = JSON.parse(localStorage.getItem('sendDoctorHistoryList'))
    this.sampleTypeHistoryList = JSON.parse(localStorage.getItem('sampleTypeHistoryList'))
    if (this.sendDoctorHistoryList === null) {
      this.sendDoctorHistoryList = []
    }
    if (this.sampleTypeHistoryList === null) {
      this.sampleTypeHistoryList = []
    }
  },
  methods: {
    pushSjbmList (val) {
      // 检查val是否已经存在于sjbmList中
      const exists = this.sjbmList.some(item => item.label === val)
      // 如果val不存在，则添加它
      if (!exists) {
        this.sjbmList.push({
          value: val,
          label: val
        })
      }
    },
    /**
     * describe 添加样本类型历史记录
     *
     * @author JKD
     * @data 2019/6/27 14:23
     */
    searchsendDoctor () {
      var val = this.caseInfoForm.sendDoctor.trim() // 清除空格
      if (val !== null && val !== '') {
        if (this.sendDoctorHistoryList !== null && this.sendDoctorHistoryList.length > 0) { // 有数据的话 判断
          if (this.sendDoctorHistoryList.indexOf(val) !== -1) { // 有相同的，先删除 再添加
            this.sendDoctorHistoryList.splice(this.sendDoctorHistoryList.indexOf(val), 1)
            this.sendDoctorHistoryList.unshift(val)
          } else { // 没有相同的 添加
            this.sendDoctorHistoryList.unshift(val)
          }
        } else { // 没有数据 添加
          this.sendDoctorHistoryList.unshift(val)
        }
        if (this.sendDoctorHistoryList.length > 6) { // 保留六个值
          this.sendDoctorHistoryList.pop()
        }
        localStorage.setItem('sendDoctorHistoryList', JSON.stringify(this.sendDoctorHistoryList))
      }
    },
    /**
     * describe 添加样本类型历史记录
     *
     * @author JKD
     * @data 2019/6/27 14:23
     */
    searchsampleType () {
      var val = this.caseInfoForm.samples[this.sampleCount].sampleTypes.trim() // 清除空格
      if (val !== null && val !== '') {
        if (this.sampleTypeHistoryList !== null && this.sampleTypeHistoryList.length > 0) { // 有数据的话 判断
          if (this.sampleTypeHistoryList.indexOf(val) !== -1) { // 有相同的，先删除 再添加
            this.sampleTypeHistoryList.splice(this.sampleTypeHistoryList.indexOf(val), 1)
            this.sampleTypeHistoryList.unshift(val)
          } else { // 没有相同的 添加
            this.sampleTypeHistoryList.unshift(val)
          }
        } else { // 没有数据 添加
          this.sampleTypeHistoryList.unshift(val)
        }
        if (this.sampleTypeHistoryList.length > 6) { // 保留六个值
          this.sampleTypeHistoryList.pop()
        }
        localStorage.setItem('sampleTypeHistoryList', JSON.stringify(this.sampleTypeHistoryList))
      }
    },
    // 选择取材完成
    complete () {
      this.isShowMaterials = false
    },
    // 取材取消
    cancel () {
      this.caseInfoForm.samples[this.sampleIndex].uploadList = []
      this.isShowMaterials = false
    },
    // 添加取材图片预览图
    getUploadList (uploadList) {
      this.caseInfoForm.samples[this.sampleIndex].uploadList = uploadList
    },
    // 获取字典表信息
    async getDicInfo () {
      let params = new URLSearchParams()
      // 证件类型，病理类型，送检部门，染色类型
      let types = 'bllx,sjbm,rslx,fxff'
      params.append('types', types)
      let suc = await this.$http.post(this.$vue.getData('GET_DIC_INFO_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.rslxList = data.rslx
        this.sjbmList = data.sjbm
        this.bllxList = data.bllx
        this.fxffList = data.fxff
        // 默认病例类型
        this.caseInfoForm.pathologyType = this.bllxList[0].value
        // 默认送检科室
        this.caseInfoForm.caseDepart = this.sjbmList[0].label
        // 默认分析类型
        this.caseInfoForm.samples[0].pathologyType = this.fxffList[0].value
      }
    },
    // 获取医院列表
    async getHospitalList () {
      let params = new URLSearchParams()
      let suc = await this.$http.post(this.$vue.getData('GET_HOSPITAL_LIST_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.sendHospitalList = data
        this.caseInfoForm.sendHospitalId = data[0].value
      }
    },

    // 显示更多病例信息方法
    showMoreCaseInfo () {
      this.isShowMoreCaseInfo = !this.isShowMoreCaseInfo
      if (this.isShowMoreCaseInfo) {
        this.moreText = this.$t('addNewCase.collapseInformation')
      } else {
        this.moreText = this.$t('addNewCase.moreInformation')
      }
    },
    // 添加样本
    handleAdd () {
      this.sampleCount++ // 样本数量自加
      this.caseInfoForm.samples.push({
        sampleTypes: '', // 样本名称
        pathologyType: '', // 分析类型
        bpsl: 1, // 玻片数量
        uploadList: [] // 取材图预览信息
      })
      this.caseInfoForm.samples[this.sampleCount].pathologyType = this.fxffList[0].value
    },
    // 打开取材台模态框
    uploadMaterials (index) {
      this.isShowMaterials = true
      this.sampleIndex = index
      this.uploadList = this.caseInfoForm.samples[this.sampleIndex].uploadList
    },
    // 删除样本
    handleRemove (index) {
      this.sampleCount-- // 样本数量自减
      this.caseInfoForm.samples.splice(index, 1)
    },
    // 校验病例信息方法
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('caseInfo', this.caseInfoForm)
        }
      })
    },
    // 提交病例信息方法
    submitCaseInfo () {
      this.handleSubmit('caseInfoForm')
    },
    // 检查送检医生名字长度
    checkSendDoctorLength () {
      if (this.caseInfoForm.sendDoctor.length > 15) {
        this.sendDoctorDisabled = false
        this.caseInfoForm.sendDoctor = this.caseInfoForm.sendDoctor.substring(0, 15)
      } else {
        this.sendDoctorDisabled = true
      }
    },
    // 检查样本类型长度
    checkSampleTypesLength (index) {
      if (this.caseInfoForm.samples[index].sampleTypes.length > 50) {
        this.sampleTypesDisabled = false
        this.caseInfoForm.samples[index].sampleTypes = this.caseInfoForm.samples[index].sampleTypes.substring(0, 50)
      } else {
        this.sampleTypesDisabled = true
      }
    },
    // 聚焦时关闭提示
    updateSampleTypesDisabled () {
      this.sampleTypesDisabled = true
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .addSample
    position : relative
    top 20px
    left 17px
  .addSample .ivu-form-item-content
    width 200px
  .delete
    width 20px
  .addSampleButton
    position relative
    left 370px
    /*width 100px*/
    margin-bottom 20px
  .ivu-col-span-7
    padding-left 19px
  .inputWidth
    width 200px
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/addCase/CaseInfo.vue